export default function MoreThanClothing() {
  const offerings = [
    {
      icon: 'ri-shirt-line',
      title: 'Clothing',
      description: 'Premium apparel designed for style and comfort'
    },
    {
      icon: 'ri-footprint-line',
      title: 'Footwear',
      description: 'Statement shoes that complete the look'
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'Accessories',
      description: 'The finishing touches that make it yours'
    },
    {
      icon: 'ri-palette-line',
      title: 'Style',
      description: 'Curated aesthetics rooted in culture'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Service',
      description: 'Support that goes beyond the transaction'
    },
    {
      icon: 'ri-community-line',
      title: 'Culture',
      description: 'Uplifting the community that built us'
    }
  ];

  return (
    <section className="py-32 px-8 bg-[#181818] border-t border-b border-[#333333]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2 mb-8">
            <span className="text-xs font-bold text-white tracking-wide">WHAT WE OFFER</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            More Than<br />
            Clothing
          </h2>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            BillPlay is a complete experience. We provide style, service, and support for the culture that raised us.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offerings.map((item, index) => (
            <div 
              key={index}
              className="bg-[#0A0A0A] border border-[#333333] rounded-2xl p-8 hover:border-white/30 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-black text-white mb-3">
                {item.title}
              </h3>
              
              <p className="text-base text-gray-400 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Statement */}
        <div className="mt-20 text-center">
          <p className="text-xl md:text-2xl text-white font-bold max-w-3xl mx-auto leading-relaxed">
            We're committed to uplifting our community and providing access—including <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">local delivery for customers who may not have transportation.</span>
          </p>
        </div>
      </div>
    </section>
  );
}